import gql from 'graphql-tag';

export default gql`
  fragment HotelOrderItemFragment on OrderItem {
    ... on HotelOrderItem {
      id
      hotelPrice: price {
        total
        totalMandatoryFees
      }
      actualPrice {
        total
      }
      paymentDueAt
      roomType
      roomsCount
      roomId
      hotelId
      hotel {
        name
        promos {
          id
          code
          headlineDescription
        }
      }
      checkin {
        time
      }
      checkout {
        time
      }
      roomsCount
      adultCount
      childrenCount
    }
  }
`;
